<ng-container *ngIf="isMobile == false && hitFooter==false">
  <div #cartIcon class="cart-fab" (click)="goToShoppingCart()" i18n-aria-label="@@shell.cart.aria" aria-label="購物車">
    <img class="cart-fab__icon" src="assets/image/redesign/shopping-bag-icon.svg" alt="" aria-hidden="true">
  </div>
</ng-container>

<ng-container *ngIf="isMobile == false && hitFooter==true">
  <div #cartIcon class="cart-fab cart-fab--pinned" (click)="goToShoppingCart()" i18n-aria-label="@@shell.cart.aria" aria-label="購物車">
    <img class="cart-fab__icon" src="assets/image/redesign/shopping-bag-icon.svg" alt="" aria-hidden="true">
  </div>
</ng-container>

<ng-container *ngIf="isMobile == true && hitFooterMobile==false">
  <div #cartIcon class="cart-fab" (click)="goToShoppingCart()" i18n-aria-label="@@shell.cart.aria" aria-label="購物車">
    <img class="cart-fab__icon" src="assets/image/redesign/shopping-bag-icon.svg" alt="" aria-hidden="true">
  </div>
</ng-container>

<ng-container *ngIf="isMobile == true && hitFooterMobile==true">
  <div #cartIcon class="cart-fab cart-fab--pinned" (click)="goToShoppingCart()" i18n-aria-label="@@shell.cart.aria" aria-label="購物車">
    <img class="cart-fab__icon" src="assets/image/redesign/shopping-bag-icon.svg" alt="" aria-hidden="true">
  </div>
</ng-container>
